import { Reveal, CTA } from "./primitives";
import { ENROLL_URL } from "../../config";

export const Vision = () => (
  <section id="vision" data-testid="vision-section" className="bg-ivory py-24 md:py-32">
    <div className="mx-auto grid max-w-[1300px] items-start gap-12 px-6 md:px-10 lg:grid-cols-12 lg:gap-20">
      {/* Photo */}
      <Reveal className="lg:col-span-5" y={50}>
        <div className="relative lg:sticky lg:top-28">
          <div className="glow-float absolute -inset-6 -z-10 rounded-full bg-terracotta/20 blur-3xl" />
          <img
            src="/images/beach.jpg"
            alt="Nichole at the shore, reflecting"
            data-testid="vision-image"
            loading="lazy"
            className="aspect-[4/5] w-full rounded-[2px] object-cover"
          />
        </div>
      </Reveal>

      {/* Text */}
      <div className="lg:col-span-7">
        <Reveal>
          <h2 className="font-display text-4xl font-medium leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl">
            Create a <span className="italic text-terracotta">different future.</span>
          </h2>
        </Reveal>

        <div className="mt-10 max-w-xl space-y-6 font-sans text-lg font-light leading-relaxed text-stonegray">
          <Reveal>
            <p>
              Not busier. Not more impressive. Not someone else's definition of success.
              <span className="text-ink"> Bigger</span> — more freedom, more adventure, more choice, more you.
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <p>A guided coaching community for women ready to build real confidence and create their own version of a wealthy life.</p>
          </Reveal>
          <Reveal delay={0.1}>
            <p>
              As you read this, notice the part of you that already knows you're
              <span className="text-ink"> meant for more.</span>
            </p>
          </Reveal>
        </div>

        {/* Feature pills */}
        <Reveal delay={0.1}>
          <div className="mt-12 flex flex-wrap gap-3">
            {["Live coaching", "Guided curriculum", "Honest community"].map((t) => (
              <span key={t} className="border border-ink/15 px-4 py-2 font-sans text-xs uppercase tracking-[0.16em] text-ink/70">
                {t}
              </span>
            ))}
          </div>
        </Reveal>

        {/* Founding rate */}
        <Reveal delay={0.12}>
          <div className="mt-8 border-l-2 border-terracotta bg-alabaster p-6 md:p-8">
            <p className="font-display text-2xl text-ink">
              Founding Member Rate — <span className="text-terracotta">$67/month</span>
            </p>
            <p className="mt-2 font-sans text-sm font-light text-stonegray">
              No contracts. Cancel anytime. Your rate is locked in for as long as you stay.
            </p>
            <div className="mt-6">
              <CTA href={ENROLL_URL} data-testid="vision-cta">Join Creating Wealth Through Community</CTA>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
